module.exports = __webpack_public_path__ + "dd9dc0e4a856aaef35fc8e193d26473d.pdf";